import React from "react";
import * as Mui from "@mui/material";
import * as Icons from "react-feather";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { statusConfig, TextingDisplayStatus } from "shared/texting-status";
import { StatusIcon } from "../status-icon";
import { styles } from "./style";

interface OwnProps {
	status: TextingDisplayStatus;
	/** Only offered when the status can be dismissed (Active). */
	onDismiss?: () => void;
	/** On the right, e.g. Resend Verification Text. */
	action?: React.ReactNode;
}

interface Props extends OwnProps, WithStyles<typeof styles> {}

/** The Texting page's one status banner; it always matches the Configuration status chip. */
const Component: React.FC<Props> = ({ classes = {}, status, onDismiss, action }) => {
	const config = statusConfig(status);
	if (!config.banner) {
		return null;
	}
	return (
		<div className={`${classes.root} ${classes[config.tone]}`} role="status" data-status={status}>
			<div className={classes.message}>
				<span className={`${classes.icon} ${classes[`${config.tone}Icon`]}`}>
					<StatusIcon icon={config.icon} />
				</span>
				<div className={classes.body}>
					<Mui.Typography className={classes.title}>{config.banner.title}</Mui.Typography>
					<Mui.Typography className={classes.text}>{config.banner.body}</Mui.Typography>
				</div>
			</div>
			{action && <div className={classes.action}>{action}</div>}
			{config.dismissable && onDismiss && (
				<Mui.IconButton className={classes.dismiss} onClick={onDismiss} aria-label="Dismiss">
					<Icons.X size={24} />
				</Mui.IconButton>
			)}
		</div>
	);
};

export const StatusBanner = withStyles(Component, styles);
